import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import {
  getRarity,
  getRarityColor,
  getAuraByName,
  formatNumber,
} from "./Functions";
import DucksIcon from "./Icons/DucksIcon";
import auraBgList from "./Backgrounds";
import Loader from "./Loader01";

const AuraItem = ({ t, aura, onClick, opacity }) => {
  const [auraDetails, setAuraDetails] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true); // Состояние загрузки изображения
  useEffect(() => {
    const fetchAuraDetails = async () => {
      let details = await getAuraByName(aura.title);
      setAuraDetails(details);
    };

    if (aura?.title) {
      // Optional chaining checks if aura exists
      fetchAuraDetails();
    }
  }, [aura?.title]); // Also use optional chaining in dependencies

  if (!auraDetails) return null;
  if (!aura || !aura.title) return null;

  const bgColor = getRarityColor(getRarity(aura?.probability));

  return (
    <motion.div
      onClick={onClick}
      whileTap={{ scale: 0.97 }}
      transition={{ duration: 0.1 }}
      style={{
        backgroundImage: `url(${auraBgList[aura.auraBg]?.auraBg})`,
        backgroundColor: auraDetails.color,
        opacity: opacity,
      }}
      className="table-item"
    >
      <div
        style={{ backgroundColor: aura.probability ? bgColor : "" }}
        className="inventory-rarity-circle"
      ></div>
      <div className="table-item-name">
        {t(aura.title)}
        {aura.auraLvl > 0 && ` +${aura.auraLvl}`}
      </div>

      <div
        className="table-item-img-container"
        style={{ position: "relative" }}
      >
        {/* {isImageLoading && (
          <div className="spinner" style={{ inset: 0 }}>
            <Loader size={80} color="white"></Loader>
          </div>
        )} */}
        <img
          className="aura-item-img"
          width={"100%"}
          src={auraDetails.miniimg}
          alt={`${aura.title} image`}
          style={{ display: isImageLoading ? "none" : "block" }}
          onLoad={() => setIsImageLoading(false)} // Изображение загружено
          onError={() => setIsImageLoading(false)} // Ошибка загрузки
        />
      </div>

      <div
        style={{
          position: "absolute",
          left: 0,
          display: "flex",
          width: "100%",
          padding: "0px 4px",
          justifyContent: "space-between",
          bottom: 4,
        }}
      >
        <div className="table-item-cost">
          {formatNumber(aura.cost)}
          <DucksIcon width={12}></DucksIcon>
        </div>
        <div className="table-item-quantity">{aura.quantity}</div>
      </div>
    </motion.div>
  );
};

export default AuraItem;
